<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [datasource]="usersDatasource"
      [rowModelType]="'infinite'"
      [columns]="columns"
      [title]="'admin.sideNav.entities.users' | translate"
      detailsBaseRoute="/admin/users"
      [loading]="isLoading()"
      (searchChange)="onSearchChange($event)"
    />
  </div>
</div>
